<template>
  <div class="container mt-5">
    <h1 class="text-center mb-4">Mis Finanzas</h1>

    <div v-if="finanzas">
      <p><strong>Total Pagado:</strong>$ {{ finanzas.totalPagado.toFixed(2) }}</p>
      <p><strong>Saldo Pendiente:</strong>$ {{ finanzas.saldoPendiente.toFixed(2) }}</p>
    </div>

    <div v-else>
      <p>Cargando información financiera...</p>
    </div>
  </div>
</template>

<script>
import { doc, getDoc } from "firebase/firestore";
import { db } from '@/firebase';  // Solo importa db si auth no se usa


export default {
  data() {
    return {
      finanzas: null,
    };
  },
  async mounted() {
    const pacienteId = this.$route.params.pacienteId;
    const docRef = doc(db, "finanzas", pacienteId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      this.finanzas = docSnap.data();
    } else {
      console.error("No se encontró información financiera.");
    }
  },
};
</script>

<style scoped>
.container {
  max-width: 900px;
}
</style>
